import { Dashboard, BlogEditor, ServiceRequests } from '../pages/admin';
import type { RouteConfig } from '../types/route';

export const adminRoutes: RouteConfig[] = [
  { path: '', component: Dashboard },
  { path: 'blog', component: BlogEditor },
  { path: 'blog/new', component: BlogEditor },
  { path: 'blog/edit/:id', component: BlogEditor },
  { path: 'requests', component: ServiceRequests }
];